import CryptoJS from 'crypto-js'
import { getDecryptedLocalItem } from '../helpers'
import { config } from '../config'

export const loadState = () => {
    try {
        const serializedState = getDecryptedLocalItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
}

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', CryptoJS.AES.encrypt(serializedState, config.crypto_key));
    } catch {
      // ignore write errors
    }
};